import type { IconSvgObject } from './types';

const SignalNo01Icon: IconSvgObject = [
  ["path", { d: "M5.5 10L5.5 19M5.5 10L8.5 5H2.5L5.5 10Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.9297 9L12.9297 15M18.9297 15L12.9297 9", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12.5 19H13.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M8.5 19H9.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M16.5 19H17.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "4" }],
  ["path", { d: "M20.5 19H21.5", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "5" }]
];

export default SignalNo01Icon;
